import { render, staticRenderFns } from "./MetricasPetmed.vue?vue&type=template&id=4ddd1868&scoped=true&"
import script from "./MetricasPetmed.vue?vue&type=script&lang=js&"
export * from "./MetricasPetmed.vue?vue&type=script&lang=js&"
import style0 from "./MetricasPetmed.vue?vue&type=style&index=0&id=4ddd1868&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ddd1868",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VCard,VCol,VContainer,VIcon,VProgressCircular,VRow,VSnackbar})
